<ng-container *ngIf="this.label">
	<div class="form-group">
		<label [for]="'input' + name" [ngClass]="classes">{{label}}<ng-content select="[labelSuffix]"></ng-content> <wd-help [name]="name"></wd-help></label>
		<ng-container *ngTemplateOutlet="contentTpl"></ng-container>
		<ng-container *ngTemplateOutlet="commentTpl"></ng-container>
	</div>
</ng-container>
<ng-container *ngIf="!this.label">
	<ng-container *ngTemplateOutlet="contentTpl"></ng-container>
	<ng-container *ngTemplateOutlet="commentTpl"></ng-container>
</ng-container>

<ng-template #contentTpl>
	<div class="input-group mb-3">
		<ng-content></ng-content>
	</div>
</ng-template>

<ng-template #commentTpl>
	<small class="form-text text-muted" [ngClass]="classes">{{helpText}}</small>
	<ng-container *ngIf="hasComments() && !hideComments">
		<div class="comment row">
			<div class="comment col" (click)="onCommentsClicked()" [ngClass]="commentsClass()">
				<div class="input-group mb-3 flex-nowrap">
					<button type="button" class="btn comment-open-btn" [ngClass]="commentsClass(comments?.resolved ? 'btn-outline-' : 'btn-')" (click)="onOpenCommentsClicked(); $event.stopPropagation()">
						<bi name="chat-left-text"></bi>
					</button>
					<input (focusout)="onCommentFocusOut(0)" [type]="canDeleteComment(0) ? 'search' : 'text'" class="form-control" [(ngModel)]="comments!.comments[0].msg" [disabled]="!canComment(0)" aria-label="Kommentar"/>
					<span class="input-group-text comment-stamp" id="basic-addon2">
						<cite>
							{{comments!.comments[0].name}}<br>{{commentTimeString(comments!.comments[0].time)}}
						</cite>
					</span>
				</div>
			</div>
		</div>
	</ng-container>
</ng-template>
